export default "/images/216e8f4453d6c2ec3fa53d795aba55d4.avif";